/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export const GetClipzyRawOpServerList = [
  "https://paste.sdjz.wiki",
] as const;

export type GetClipzyRawRequest = { id: string; key: string };

export const GetClipzyRawRequest$zodSchema: z.ZodType<GetClipzyRawRequest> = z
  .object({
    id: z.string().describe("片段的唯一 ID。"),
    key: z.string().describe("用于解密的 Base64 编码的 AES 密钥。"),
  });

/**
 * 片段未找到。它可能已过期、被删除或ID不正确。
 */
export type GetClipzyRawNotFoundResponseBody = { error?: string | undefined };

export const GetClipzyRawNotFoundResponseBody$zodSchema: z.ZodType<
  GetClipzyRawNotFoundResponseBody
> = z.object({
  error: z.string().optional(),
}).describe("片段未找到。它可能已过期、被删除或ID不正确。");

/**
 * 禁止访问。提供的密钥无法解密对应的数据。
 */
export type GetClipzyRawForbiddenResponseBody = { error?: string | undefined };

export const GetClipzyRawForbiddenResponseBody$zodSchema: z.ZodType<
  GetClipzyRawForbiddenResponseBody
> = z.object({
  error: z.string().optional(),
}).describe("禁止访问。提供的密钥无法解密对应的数据。");

/**
 * 请求参数错误，缺少 ID 或密钥。
 */
export type GetClipzyRawBadRequestResponseBody = { error?: string | undefined };

export const GetClipzyRawBadRequestResponseBody$zodSchema: z.ZodType<
  GetClipzyRawBadRequestResponseBody
> = z.object({
  error: z.string().optional(),
}).describe("请求参数错误，缺少 ID 或密钥。");

export type GetClipzyRawResponse =
  | string
  | GetClipzyRawBadRequestResponseBody
  | GetClipzyRawForbiddenResponseBody
  | GetClipzyRawNotFoundResponseBody;

export const GetClipzyRawResponse$zodSchema: z.ZodType<GetClipzyRawResponse> = z
  .union([
    z.string().describe("解密并获取成功！响应体为纯文本内容。"),
    z.lazy(() => GetClipzyRawBadRequestResponseBody$zodSchema),
    z.lazy(() => GetClipzyRawForbiddenResponseBody$zodSchema),
    z.lazy(() => GetClipzyRawNotFoundResponseBody$zodSchema),
  ]);
